import getActivePanel from '../../leadform/models/form/get_active_panel';

/**
 * Returns true if the form is showing a loading animation
 * @param {Element} form
 */
export function isLoading(form) {
  const button = getActivePanel(form).querySelector('.edge-button--primary');
  return button.classList.contains('edge-button--loading');
}

/**
 * Enables or disables the loading animation on the form's current panel
 * @param {Element} form
 * @param {Boolean} show - Whether to turn on or off the animation
 */
export function setLoading(form, show = true) {
  const button = getActivePanel(form).querySelector('.edge-button--primary');
  if(show) button.classList.add('edge-button--loading');
  if(!show) button.classList.remove('edge-button--loading');
}
